import { LocalStorage, LocalStorageKeys } from 'helpers/localStorage';

export const pendingGoogleAuthStorage = new LocalStorage<boolean, boolean>(
  LocalStorageKeys.PendingGoogleAuth,
  false,
  () => sessionStorage
);

export const googleAuthRedirectStorage = new LocalStorage<string, null>(
  LocalStorageKeys.GoogleAuthRedirect,
  null,
  () => sessionStorage
);
